<template lang="html">
  <div class="item-description-wrapper">
    <div class="description-title">
      {{ description.pro_name }}
    </div>
    <div class="description-prices main">
      <div
        class="description-price"
        v-for="(price, index) in description.prices"
        :key="index"
      >
        <span class="price"
          >{{
            price.price
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          <span>{{ description.cur_id }}</span></span
        >
        <span
          v-if="price.min === price.max || (price.min === 0 && price.max === 1)"
          class="range"
          ><b>{{
            price.max
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}</b>
          {{
            description.mun_unit === "komad" ||
            description.mun_unit === "komada"
              ? $t("item.items")
              : description.mun_unit
          }}</span
        >
        <span v-else class="range"
          ><b>{{
            price.min
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}</b>
          {{ $t("item.to") }}
          <b>{{
            price.max
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}</b>
          {{
            description.mun_unit === "komad" ||
            description.mun_unit === "komada"
              ? $t("item.items")
              : description.mun_unit
          }}</span
        >
      </div>
    </div>
    <div v-if="!hover">
      <div class="description-expire">
        <span class="description-offer">{{ $t("item.offerStands") }}</span>
        <span class="description-expire-date">{{
          $moment
            .utc(description.pro_expiry)
            .local()
            .format("YYYY-MM-DD HH:mm")
        }}</span>
      </div>
      <div class="description-user">
        <span class="description-username">{{ description.usr_name }}</span>
        <div v-if="description.rating" class="description-rate-wrapper">
          <span class="rate-title">{{ $t("item.rate") }}:</span>
          <span class="rate">{{ description.rating.toFixed(1) }}</span>
        </div>
      </div>
    </div>
    <div v-else class="description-prices hover">
      <div class="description-price">
        <span class="range"
          ><b>{{ $t("item.currentlyReserved") }}</b></span
        >
        <span class="price">{{
          description.off_count
            .toLocaleString("en")
            .split(",")
            .join(".")
        }}</span>
      </div>
      <div class="description-price">
        <span class="range"
          ><b>{{ $t("item.currentPrice") }}</b></span
        >
        <span class="price"
          >{{
            description.current_price
              .toLocaleString("en")
              .split(",")
              .join(".")
          }}
          {{ description.cur_id }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "itemDescription",
  props: {
    description: {
      required: true,
      type: Object
    },
    hover: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.item-description-wrapper {
  padding: 0 15px;

  .description-title {
    text-align: left;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 26px;
    color: $text-color;
    margin-bottom: 20px;
    margin-top: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  .description-title::first-letter {
    text-transform: uppercase;
  }
  .description-prices.main {
    min-height: 75px;
  }
  .description-prices {
    margin-bottom: 20px;

    .description-price {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 6px;
      gap: 10px;

      .price {
        color: $main-color;
        font-style: normal;
        font-weight: 800;
        font-size: 13px;
        line-height: 21px;
        text-align: left;

        span {
          text-transform: uppercase;
        }
      }
      .range {
        font-size: 13px;
        line-height: 21px;
        color: #484848;
        text-align: right;
      }
    }
  }
  .description-prices.hover {
    margin-bottom: 10px;
    height: 51px;

    .price {
      font-size: 15px;
    }
  }
  .description-expire {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 5px;

    .description-offer {
      font-weight: bold;
      font-size: 14px;
      line-height: 23px;
      color: $text-color;
    }
    .description-expire-date {
      font-weight: bold;
      font-size: 13px;
      line-height: 21px;
      color: #484848;
    }
  }
  .description-user {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 10px;

    .description-username {
      text-transform: uppercase;
      color: $text-color;
      font-weight: bold;
      font-size: 14px;
      line-height: 23px;
    }
    .rate-title {
      font-size: 13px;
      line-height: 21px;
      color: #484848;
      margin-right: 5px;
    }
    .rate {
      color: $main-color;
      font-weight: bold;
      font-size: 13px;
    }
  }
}
</style>
